export interface ApplicationV2 {
  id: number;
  code: string;
  name: string;
  data: object;
  sort_order: number;
  permissions: string[];
  roles: string[];
}

export interface ApplicationV2Payload {
  name: string;
  sort_order: number;
}

export enum APPLICATION_NAMES {
  PLATFORM = "Platform",
  OCCUPANCY_PLANNING = "Occupancy Planning",
  TRANSACTION_STRATEGY = "Transaction Strategy",
  MARKET_CANVAS = "Market Canvas",
  OPPORTUNITY_SPOTTING = "Opportunity Spotting",
  FAST_MK2 = "Fast & MK2",
  CANVAS_ZIP = "Canvas ZIP",
}

export enum APPLICATION_CODES {
  PLATFORM = "PLATFORM",
  OCCUPANCY_PLANNING = "OCCUPANCY_PLANNING",
  TRANSACTION_STRATEGY = "TRANSACTION_STRATEGY",
  MARKET_CANVAS = "MARKET_CANVAS",
  OPPORTUNITY_SPOTTING = "OPPORTUNITY_SPOTTING",
  FAST_MK2 = "FAST_MK2",
  CANVAS_ZIP = "CANVAS_ZIP",
}

export enum APPLICATION_ID {
  PLATFORM = 1,
  OCCUPANCY_PLANNING = 2,
  TRANSACTION_STRATEGY = 3,
  MARKET_CANVAS = 4,
  OPPORTUNITY_SPOTTING = 5,
  FAST_MK2 = 6,
}
